import React, { useMemo, useState } from 'react'
import ModalFeedback from '../components/ModalFeedback'

export default function useModalFeedback() {
  const [messageModal, setMessageModal] = useState({ open: false, title: 'Notification', message: '' })
  const [confirmModal, setConfirmModal] = useState({ open: false, title: 'Confirm', message: '', resolver: null })

  const showMessage = (message, title = 'Notification') => {
    setMessageModal({ open: true, title, message: String(message || '') })
  }

  const closeMessage = () => {
    setMessageModal({ open: false, title: 'Notification', message: '' })
  }

  const showConfirm = (message, title = 'Confirm') => {
    return new Promise((resolve) => {
      setConfirmModal({
        open: true,
        title,
        message: String(message || ''),
        resolver: resolve
      })
    })
  }

  const closeConfirmWith = (value) => {
    if (confirmModal.resolver) {
      confirmModal.resolver(value)
    }
    setConfirmModal({ open: false, title: 'Confirm', message: '', resolver: null })
  }

  const modalElement = useMemo(() => (
    <ModalFeedback
      messageModal={messageModal}
      confirmModal={confirmModal}
      onCloseMessage={closeMessage}
      onConfirm={() => closeConfirmWith(true)}
      onCancel={() => closeConfirmWith(false)}
    />
  ), [messageModal, confirmModal])

  return {
    showMessage,
    showConfirm,
    modalElement
  }
}
